import { toArrayBuffer } from '@kitware/vtk.js/Common/Core/Base64';
import { TYPED_ARRAYS } from '@kitware/vtk.js/macros';
import { NUMPY_DTYPES } from './numpy.js';

const TypedArrayLookup = {
    [TYPED_ARRAYS.Uint8Array]: Uint8Array,
    [TYPED_ARRAYS.Uint16Array]: Uint16Array,
    [TYPED_ARRAYS.Uint32Array]: Uint32Array,
    [TYPED_ARRAYS.Int8Array]: Int8Array,
    [TYPED_ARRAYS.Int16Array]: Int16Array,
    [TYPED_ARRAYS.Int32Array]: Int32Array,
    [TYPED_ARRAYS.Float32Array]: Float32Array,
    [TYPED_ARRAYS.Float64Array]: Float64Array,
};
function dataArraySize(v) {
    if ('length' in v)
        return v.length;
    return v.shape.reduce((size, dim) => size * dim, 1);
}
function toTypedArray(values, constructor) {
    if (Array.isArray(values)) {
        return constructor.from(values);
    }
    if ('dtype' in values) {
        const { bvals, dtype } = values;
        const arrayBuffer = toArrayBuffer(bvals);
        return new NUMPY_DTYPES[dtype](arrayBuffer);
    }
    return values;
}
function pick(source, ...keys) {
    const lookup = new Set(keys);
    return Object.entries(source)
        .filter(([key]) => lookup.has(key))
        .reduce((out, [key, value]) => (Object.assign(Object.assign({}, out), { [key]: value })), {});
}
function omit(source, ...keys) {
    const lookup = new Set(keys);
    return Object.entries(source)
        .filter(([key]) => !lookup.has(key))
        .reduce((out, [key, value]) => (Object.assign(Object.assign({}, out), { [key]: value })), {});
}

export { TypedArrayLookup, dataArraySize, omit, pick, toTypedArray };
